/* JAYKEI header: transparent -> solid on scroll, plus the Shop mega menu. */
(function () {
  'use strict';

  var ENTER = 8; // px scrolled before going solid
  var EXIT = 4;  // px to fall back under before going transparent again (hysteresis)

  function initScrollState(header) {
    // Only homepage (or whatever templates the merchant lists) starts transparent.
    if (header.dataset.transparent !== 'true') return;

    var solid = null; // unknown until first measure
    var ticking = false;

    function apply() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      // Hysteresis: once solid, require dropping below EXIT to go back.
      var next = solid ? y > EXIT : y > ENTER;
      if (next === solid) return;
      solid = next;
      header.classList.toggle('jk-header--transparent', !solid);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    apply(); // respect a restored scroll position on load
  }

  function initMega(header) {
    var trigger = header.querySelector('[data-mega-trigger]');
    var panel = header.querySelector('[data-mega-panel]');
    if (!trigger || !panel) return;

    var closeTimer = null;

    function open() {
      window.clearTimeout(closeTimer);
      panel.dataset.open = 'true';
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.dataset.open = 'false';
      trigger.setAttribute('aria-expanded', 'false');
    }
    function closeSoon() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(close, 120);
    }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    // Shop is a link: with a mouse, hover has already opened the panel, so a
    // click goes through to the page. A touch screen has no hover, so there the
    // first tap opens the panel and a second tap follows the link.
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    trigger.addEventListener('click', function (e) {
      if (canHover || panel.dataset.open === 'true') return;
      e.preventDefault();
      open();
    });
    panel.addEventListener('mouseenter', open);

    trigger.addEventListener('mouseleave', closeSoon);
    panel.addEventListener('mouseleave', closeSoon);

    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.dataset.open === 'true') {
        close();
        trigger.focus();
      }
    });

    // Close when focus leaves the header entirely (keyboard users tabbing out).
    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) close();
    });

    // Category column swaps the subcategory list.
    panel.querySelectorAll('[data-mega-cat]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { selectCat(panel, btn); });
      btn.addEventListener('focus', function () { selectCat(panel, btn); });
    });

    // Sub-categories preview their own picture, then hand it back to whichever
    // category is open once the pointer leaves the list.
    panel.querySelectorAll('[data-mega-sub] [data-mega-image]').forEach(function (link) {
      var show = function () { setMedia(panel, link.dataset.megaImage, link.getAttribute('href')); };
      link.addEventListener('mouseenter', show);
      link.addEventListener('focus', show);
    });
    panel.querySelectorAll('[data-mega-sub]').forEach(function (group) {
      group.addEventListener('mouseleave', function () {
        var cur = panel.querySelector('[data-mega-cat][aria-current="true"]');
        if (cur) setMedia(panel, cur.dataset.megaImage, cur.getAttribute('href'));
      });
    });
  }

  function setMedia(panel, src, href) {
    var media = panel.querySelector('[data-mega-media]');
    if (media && src) media.src = src;
    // The image is a shortcut to whatever it is showing, so its link follows too.
    var mediaLink = panel.querySelector('[data-mega-media-link]');
    if (mediaLink && href) mediaLink.setAttribute('href', href);
  }

  function selectCat(panel, btn) {
    panel.querySelectorAll('[data-mega-cat]').forEach(function (b) {
      b.setAttribute('aria-current', String(b === btn));
    });
    var key = btn.dataset.megaCat;
    panel.querySelectorAll('[data-mega-sub]').forEach(function (group) {
      group.hidden = group.dataset.megaSub !== key;
    });
    setMedia(panel, btn.dataset.megaImage, btn.getAttribute('href'));
  }

  // Slide the header down after the preloader leaves. Only relevant where a
  // preloader exists (homepage); everywhere else the header is just there.
  function initIntro(header) {
    var pre = document.getElementById('jk-preloader');
    if (!pre) return;
    if (header.classList.contains('jk-header--in')) return;

    header.classList.add('jk-header--intro');
    var slide = function () {
      // next frame, so the starting transform is committed before transitioning
      window.requestAnimationFrame(function () { header.classList.add('jk-header--in'); });
    };
    document.addEventListener('jk:preloader-done', slide, { once: true });
    // if the preloader is torn down without firing, don't strand the header
    window.setTimeout(function () {
      if (!document.getElementById('jk-preloader')) slide();
    }, 9000);
  }


  function initDrawer(header) {
    var toggle = header.querySelector('[data-drawer-toggle]');
    // The drawer lives OUTSIDE <header> - the header's intro transform would
    // otherwise act as the containing block and clip a position:fixed panel.
    var drawer = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    var scrim = document.querySelector('[data-drawer-scrim]');
    if (!toggle || !drawer || !scrim) return;
    if (drawer.dataset.ready === 'true') return;
    drawer.dataset.ready = 'true';

    var root = document.documentElement;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      // The panel tucks under the fixed header, so its first item has to clear
      // whatever the header currently measures (the announcement bar collapses
      // on scroll, so this is not a constant).
      var hh = header.getBoundingClientRect().height;
      root.style.setProperty('--jk-drawer-top', Math.round(hh) + 'px');
      header.classList.add('jk-header--drawer-open');
      drawer.dataset.open = 'true';
      scrim.dataset.open = 'true';
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      root.classList.add('jk-drawer-open');
      // focus the first thing inside so keyboard users land in the panel
      var first = drawer.querySelector('a, button');
      if (first) first.focus({ preventScroll: true });
    }

    function close(returnFocus) {
      header.classList.remove('jk-header--drawer-open');
      drawer.dataset.open = 'false';
      scrim.dataset.open = 'false';
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      root.classList.remove('jk-drawer-open');
      if (returnFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    toggle.addEventListener('click', function () {
      drawer.dataset.open === 'true' ? close(true) : open();
    });
    scrim.addEventListener('click', function () { close(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || drawer.dataset.open !== 'true') return;
      close(true);
    });

    // Follow a link and the drawer should not still be sitting there on return.
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) close(false);
    });

    // Accordion for the mega-menu column.
    drawer.querySelectorAll('[data-drawer-acc]').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      btn.addEventListener('click', function () {
        var openNow = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!openNow));
        panel.hidden = openNow;
      });
    });

    // Resizing up to desktop must not leave the page scroll-locked behind a
    // drawer that is now display:none.
    var mq = window.matchMedia('(min-width: 990px)');
    var onChange = function (e) { if (e.matches && drawer.dataset.open === 'true') close(false); };
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
  }

  function init() {
    document.querySelectorAll('[data-jk-header]').forEach(function (header) {
      initIntro(header);
      initScrollState(header);
      initMega(header);
      initDrawer(header);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', init);
})();
